// src/hooks/useReloadOnFocus.js
//
// Вызывает callback когда пользователь возвращается на страницу:
// - после переключения вкладки в браузере
// - после возврата из фонового режима APK
// - после блокировки/разблокировки экрана
//
// Минимум 30 секунд между вызовами — чтобы не дёргать сервер при быстрых переключениях.

import { useEffect, useRef } from 'react';

const MIN_INTERVAL_MS = 30 * 1000;

export function useReloadOnFocus(callback) {
  const lastCallRef = useRef(Date.now());
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastCallRef.current < MIN_INTERVAL_MS) return;
      lastCallRef.current = now;
      try { callbackRef.current?.(); } catch (e) { /* ignore */ }
    };

    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);

    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', onVisible);
    };
  }, []);
}
